import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import Toolbar from "@mui/material/Toolbar"
import Typography from "@mui/material/Typography"
import { useAppDispatch, useAppSelector } from "app/hooks"
import { logout, selectUser } from "app/userSlice"
import PmLogo from "components/PmLogo/PmLogo"
import { useCallback } from "react"
import { TopNavigation } from "./TopNavigation"

const Navbar = () => {
  const dispatch = useAppDispatch()
  const us = useAppSelector(selectUser)
  const handleLogout = useCallback(() => dispatch(logout()), [dispatch])

  return (
    <AppBar color="inherit" position="static" sx={{ marginBottom: 2 }}>
        <Toolbar disableGutters>
          <Box sx={{ marginTop: 1, marginRight: 3 }}>
            <PmLogo />
          </Box>
          <TopNavigation />
          <Box
            sx={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <Typography>{us.user?.username}</Typography>
            <IconButton
              aria-label="logout button"
              onClick={handleLogout}
              color="error"
            >
              <PowerSettingsNewIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </Box>
        </Toolbar>
    </AppBar>
  )
}
export default Navbar
